<template>
  <div>
    <legacy-sign-up-card v-if="legacySignUpCard"></legacy-sign-up-card>
    <legacy-sign-in-card v-if="legacySignInCard"></legacy-sign-in-card>
  </div>
</template>

<script>
  import LegacySignUpCard from '../ui-components/card/legacy-sign-up-card'
  import LegacySignInCard from '../ui-components/card/legacy-sign-in-card'
  import * as routes from '../../enums/routes'

  export default {
    name: 'LegacyAccount',
    components: {
      LegacySignUpCard,
      LegacySignInCard
    },
    data() {
      return {
        legacySignUpCard: false,
        legacySignInCard: false
      }
    },
    metaInfo() {
      return {
        meta: [
          { name: 'robots',
            content: 'noindex'
          }
        ]
      }
    },
    methods: {
      routeHandler(value) {
        switch (value.name) {
          case routes.LEGACY_SIGN_UP:
            this.legacySignUpCard = true
            break
          case routes.LEGACY_SIGN_IN:
            this.legacySignInCard = true
            break
          default:
            break
        }
      }
    },
    created() {
      this.routeHandler(this.$route)
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints';
  @import '../../styles/colours';

  .app-container {
    -webkit-animation: fadein 3s; /* Safari, Chrome and Opera > 12.1 */
    -moz-animation: fadein 3s; /* Firefox < 16 */
    -ms-animation: fadein 3s; /* Internet Explorer */
    -o-animation: fadein 3s; /* Opera < 12.1 */
    animation: fadein 3s;
  }

  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  /* Opera < 12.1 */
  @-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
    @media screen and (max-width: $breakpoint-medium) {
      .app-container {
        width: 100%;
      }
    }
</style>

